import Button from "components/base/Button";
import { Alert, Form, InputGroup, ListGroup } from "react-bootstrap";

const ResetPasswordForm = ({
  onSubmit,
  validationError,
  loading,
}: {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  validationError: string | null;
  loading: boolean;
}) => {
  // Determine if this is a password mismatch error
  const isPasswordMismatch = validationError?.includes("não coincidem");

  // Check for password complexity error
  const isComplexityError =
    validationError?.includes("caractere não alfanumérico") ||
    validationError?.includes("letra maiúscula") ||
    validationError?.includes("mínimo");

  // Split multiple error messages for better display
  const errorMessages = validationError?.split(". ").filter(Boolean) || [];

  return (
    <div className="text-center mb-6">
      <h4 className="text-body-highlight">Crie uma nova senha</h4>
      <p className="text-body-tertiary">Digite sua nova senha abaixo</p>
      <Form className="mt-5" onSubmit={onSubmit}>
        {validationError && isComplexityError && (
          <Alert variant="subtle-warning" className="mt-3 mb-3 text-start">
            <strong>Requisitos de senha:</strong>
            <ListGroup variant="flush" className="mt-2 border-0">
              {errorMessages.map((error, index) => (
                <ListGroup.Item
                  key={index}
                  className="border-0 bg-transparent ps-2 py-1"
                >
                  • {error}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Alert>
        )}

        {validationError && !isComplexityError && !isPasswordMismatch && (
          <Alert variant="subtle-danger" className="mt-3 mb-3 text-star">
            <strong>Erro: </strong>
            {validationError}
          </Alert>
        )}
        <Form.Control
          className="mb-2"
          id="password"
          type="password"
          placeholder="Digite uma nova senha"
          required
          isInvalid={!!validationError && !isPasswordMismatch}
        />

        <InputGroup hasValidation className="mb-3">
          <Form.Control
            id="confirmPassword"
            type="password"
            placeholder="Confirme a nova senha"
            required
            isInvalid={!!isPasswordMismatch}
          />
          {isPasswordMismatch && (
            <Form.Control.Feedback type="invalid">
              {validationError}
            </Form.Control.Feedback>
          )}
        </InputGroup>

        <Button
          variant="primary"
          className="mt-4 w-100"
          type="submit"
          loading={loading}
          disabled={loading}
          loadingPosition="end"
        >
          Criar nova senha
        </Button>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
